import {} from 'jquery-ujs'

import 'jquery';
import 'jquery-ui/ui/widgets/accordion';
window.$ = $;

import 'bootstrap-sass/assets/javascripts/bootstrap';
import '@fortawesome/fontawesome-free/css/all.css'; // This is huge, we should import specific icons.
import '../stylesheets/application.scss';

import BaseComponent from '../../components/base_component/base_component';
window.BaseComponent = BaseComponent;
import '../javascripts/offline_handler';
import '../javascripts/component_builder';
import router from '../javascripts/router';
window.loadPage = router.loadPage.bind(router);

import '../images/header-motif.png';

require.context('../images', true)

let result = false;
if (result) {
    let logo = 'logo.png';
    require(`../images/liquid/${logo}`); // Forces webpack to pack entire liquid folder.
}
